var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.332 13.6667H4.66536C2.66536 13.6667 1.33203 12.6667 1.33203 10.3334V5.66671C1.33203 3.33337 2.66536 2.33337 4.66536 2.33337H11.332C13.332 2.33337 14.6654 3.33337 14.6654 5.66671V10.3334C14.6654 12.6667 13.332 13.6667 11.332 13.6667Z",
    stroke: "#B6BAC4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3346 6L9.24797 7.66667C8.5613 8.21333 7.43463 8.21333 6.74797 7.66667L4.66797 6",
    stroke: "#B6BAC4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.362383a45956311b7d73ca3f5711fee7.svg";
export { ForwardRef as ReactComponent };